import { registerPlugin } from '@capacitor/core';
import { isNativeShell } from '../auth/authRedirect';

const LineMedicNfc = registerPlugin('LineMedicNfc');

export function nativeNfcAvailable() {
  return isNativeShell();
}

export async function addNativeGearScanListener(listener) {
  if (!nativeNfcAvailable()) throw new Error('Native NFC is only available in the iPhone app.');
  return LineMedicNfc.addListener('gearTagScanned', event => {
    const assetId = String(event?.assetId || '').trim();
    if (assetId) listener?.(assetId, event || {});
  });
}

export async function setNativeGearScanFeedback({ assetId = '', status = 'added', message = '' } = {}) {
  if (!nativeNfcAvailable()) return { active: false };
  return LineMedicNfc.scanFeedback({
    assetId: String(assetId || '').trim(),
    status: String(status || 'added').trim(),
    message: String(message || '').trim(),
  });
}

export async function scanNativeGearTags(options = {}) {
  if (!nativeNfcAvailable()) throw new Error('Native NFC is only available in the iPhone app.');
  const result = await LineMedicNfc.scanTags({
    mode: options.mode || 'read',
    allowMultiple: options.allowMultiple !== false,
  });
  return Array.isArray(result?.assetIds) ? result.assetIds : [];
}

export async function writeNativeGearTag(assetUrl) {
  if (!nativeNfcAvailable()) throw new Error('Native NFC is only available in the iPhone app.');
  const url = String(assetUrl || '').trim();
  if (!url) throw new Error('A gear URL is required.');
  return LineMedicNfc.writeTag({ url });
}
